import styled from '@emotion/styled';
import { Table as BaseTable, Td, Th, Tr } from '@lightspeed/cirrus-table';

const Table = styled(BaseTable)`
  border: solid rgb(215, 220, 225);
  border-width: 1px 0;
  color: #020203;

  input {
    border-radius: 3px;
  }

  a {
    color: #2e61de;
    font-weight: 700;
  }
`;

const ForecastThLight = styled(Th)`
  background: #f5f7ff;
`;

const ForecastTdLight = styled(Td)`
  background: #f5f7ff;
  text-align: right;
`;

// The forecast headers are a different color than the flame components.
// The loading bar is designed with white headers, so the ::after help
// fill the color below the headers where the loading bar is.
const HeaderWithForecasts = styled(Tr)`
  th:nth-last-of-type(-n + 3) {
    background: #d6dffd;
    position: relative;
    > button {
      background: #d6dffd;
    }
    &::after {
      content: ' ';
      position: absolute;
      bottom: -1px;
      left: -1px;
      width: 100%;
      background: #d6dffd;
      height: 1px;
      border-left: solid 1px #d7dce1;
    }
  }
  th:nth-last-of-type(3) {
    border-left: solid 1px #d7dce1;
  }
`;

const OverlayDiv = styled.div`
  position: absolute;
  inset: 0;
  backdrop-filter: blur(3px);
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    text-align: center;
  }
`;

export { Table, ForecastThLight, ForecastTdLight, HeaderWithForecasts, OverlayDiv };
